import { useEffect, useState } from "react"

/**
 * Simple hook to determine if the screen is currently mobile-sized.
 * Listens for window resize events to update the value.
 *
 * @param breakpoint The width in pixels below which the screen is considered mobile.
 * @returns A boolean indicating if the screen is currently mobile-sized.
 */
const useIsMobile = (breakpoint = 655) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint)
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [breakpoint])
  return isMobile
}

export default useIsMobile
